<template>
  <div>
  <!--타이틀-->
  <el-row class="wordCountInfo" style="height: 100%; overflow: hidden">
    <div style="width:89%; float:left">
      <div class="title-bar" style="height: 43px; margin: 0 !important">
        <h3>로그 연관 단어 발생횟수</h3>
      </div>
      <p>발생한 글자 수 목록</p>
    </div>
    <div style="width: 100%; float:left; margin-top: 20px">
      <div>
        <el-table-wrapper
          class="mr-b20"
          :column-default="columnDefault"
          ref="logGroupTable"
          :data="groupData"
          :columns="groupColumn"
          :pagination="false"
          :show-custom-header="false"
          header-align="center"
          :show-search-tool="showSearchTool"
          @cell-click="selectGroup"
          highlight-current-row
          height="166">
          <template slot-scope="scope" slot="groupName-slot">
            <span class="c-pointer">
              {{scope.row.groupName}}
            </span>
          </template>
        </el-table-wrapper>
      </div>
      <div>
        <el-table-wrapper
          :column-default="columnDefault"
          ref="logNodeTable"
          :data="wordCountData"
          :columns="nodeColumn"
          :pagination="false"
          header-align="center"
          :show-custom-header="false"
          :show-search-tool="showSearchTool"
          highlight-current-row
          @cell-click="wordClick"
          :height="height">
          <template slot-scope="scope" slot="wordCount-slot">
            <span class="c-pointer">
              {{scope.row.wordCount}}
            </span>
          </template>
        </el-table-wrapper>
      </div>
    </div>
  </el-row>
</div>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import { columnDefault } from '@/constants/table';

export default {
  name: 'WLogWordChartEventInfo',
  props: {
    wordCount: {
      type: Array,
    },
  },
  data() {
    return {
      columnDefault,
      showSearchTool: false,
      groupData: [],
      nodeData: [],
      height: 0,
      wordCountData: [],
      nodeColumn: [
        {
          label: '발생 횟수',
          prop: 'wordCount',
          scopedSlot: 'wordCount-slot',
        },
      ],
      groupColumn: [
        {
          prop: 'groupName',
          label: '그룹 명',
          scopedSlot: 'groupName-slot',
        },
      ],
    };
  },
  watch: {
    wordCount() {
      this.groupData = [];
      this.nodeData = [];
      const wordCountElem = document.getElementsByClassName('wordCountInfo')[0];
      const height = wordCountElem.getBoundingClientRect().height;
      this.height = height - 260;
      this.setWordTreeData();
    },
  },
  methods: {
    selectGroup(data) {
      const tempData = cloneDeep(this.nodeData);
      this.wordCountData = tempData.filter((item) => data.groupName === item.group);
    },
    wordClick(data) {
      if (!isNil(data.message)) {
        this.$emit('wordClick', data.message);
      }
    },
    /**
     * 트리 데이터 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    setWordTreeData() {
      const wordData = cloneDeep(this.wordCount);
      // const treeData = [];
      wordData.sort((a, b) => {
        if (a.size > b.size) {
          return -1;
        } else if (a.size < b.size) {
          return 1;
        }
        return 0;
      });

      wordData.forEach((item) => {
        const isExist = this.groupData.find((data) => item.group === data.groupName);
        if (isExist) {
          this.nodeData.push({ wordCount: `${item.name} : ${item.size}개`, group: `${item.group}`, message: item.name });
        } else {
          this.groupData.push({ groupName: `${item.group}` });
          this.nodeData.push({ wordCount: `${item.name} : ${item.size}개`, group: `${item.group}`, message: item.name });
        }
      });
      const tempData = cloneDeep(this.nodeData);
      this.wordCountData = tempData;
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  line-height: 4px;
  color: #999; //$lightgray
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/log/components/analysis/LogWordChartEventInfo.vue